import { default as index4PZzyyUOK2Meta } from "/app/dev/pages/index.vue?macro=true";
import { default as preferencesXUewv1wsVPMeta } from "/app/dev/pages/preferences.vue?macro=true";
import { default as questionnaire0IOtvpQGepMeta } from "/app/dev/pages/questionnaire.vue?macro=true";
import { default as referralipa9W473AKMeta } from "/app/dev/pages/referral.vue?macro=true";
import { default as registrationU5g0HztpwiMeta } from "/app/dev/pages/registration.vue?macro=true";
import { default as statsBPs56fUqmTMeta } from "/app/dev/pages/stats.vue?macro=true";
import { default as test_45drive2SMueFDgW2Meta } from "/app/dev/pages/test-drive.vue?macro=true";
import { default as verificationdjKKVU6Od4Meta } from "/app/dev/pages/verification.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "preferences",
    path: "/preferences",
    component: () => import("/app/dev/pages/preferences.vue").then(m => m.default || m)
  },
  {
    name: "questionnaire",
    path: "/questionnaire",
    component: () => import("/app/dev/pages/questionnaire.vue").then(m => m.default || m)
  },
  {
    name: "referral",
    path: "/referral",
    component: () => import("/app/dev/pages/referral.vue").then(m => m.default || m)
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/app/dev/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: "stats",
    path: "/stats",
    component: () => import("/app/dev/pages/stats.vue").then(m => m.default || m)
  },
  {
    name: "test-drive",
    path: "/test-drive",
    component: () => import("/app/dev/pages/test-drive.vue").then(m => m.default || m)
  },
  {
    name: "verification",
    path: "/verification",
    component: () => import("/app/dev/pages/verification.vue").then(m => m.default || m)
  }
]